import {Stack} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import userSettingsService from "../../../../common/apis/user/UserSettingsService";
import {GridPresets} from "../../../../components/grid/presets/GridPresets";
import Page from "../../../../components/page/Page";
import PageContent from "../../../../components/page/PageContent";
import PageHeader from "../../../../components/page/PageHeader";
import PageTitle from "../../../../components/page/PageTitle";
import {_transl} from "../../../../store/localization/TranslMessasge";
import {IApplicationState} from "../../../../store/Store";
import DiagramsFilter from "./DiagramsFilter";
import {DiagramsGrid} from "./DiagramsGrid";
import {DiagramTranslationKey} from "./DiagramTranslationKey";
import RenderMode from "./RenderMode";


export default function DiagramsPage() {

    const filter = useSelector((state: IApplicationState) => state.pages.diagrams.filter.submittedFilter.lastFilter);

    const [gridPresets, setGridPresets] = useState<GridPresets>();
    const [presetsLoaded, setPresetsLoaded] = useState<boolean>(false);

    function loadPresets(): void {
        userSettingsService.getDiagramsGridSettings()
                .then(value => {
                    setGridPresets(value);
                    setPresetsLoaded(true);
                });
    }

    function saveGridPresets(presets: GridPresets): void {
        userSettingsService.updateDiagramsGridSettings(presets)
                .then(() => setGridPresets(presets))
    }

    useEffect(() => loadPresets(), []);

    return (
            <Page>
                <PageHeader>
                    <PageTitle title={_transl(DiagramTranslationKey.DIAGRAMS_TITLE)}/>
                </PageHeader>
                <PageContent>
                    <Stack spacing={2}>
                        <DiagramsFilter renderMode={RenderMode.PAGE}/>
                        {presetsLoaded &&
                                <DiagramsGrid
                                        filter={filter}
                                        presets={gridPresets}
                                        onPresetsChanged={saveGridPresets}/>
                        }
                    </Stack>
                </PageContent>
            </Page>
    )
}
